import { useState } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import toast from 'react-hot-toast';
import api from '../../utils/api';
import '../../styles/Pages.css';

function GrievanceCell() {
    const [form, setForm] = useState({ name: '', email: '', phone: '', department: '', year: '', message: '' });
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.message.trim()) return toast.error('Please describe your grievance.');
        setSubmitting(true);
        try {
            await api.post('/contact', { ...form, type: 'grievance' });
            toast.success('Your grievance has been submitted. We will get back to you within 7 working days.');
            setForm({ name: '', email: '', phone: '', department: '', year: '', message: '' });
        } catch {
            toast.error('Submission failed. Please try again or contact the college office directly.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Students Corner › Grievance Redressal Cell</p>
                <h1>Students' Grievance Redressal Cell</h1>
                <p>A safe and confidential platform for students to voice concerns.</p>
            </div>
            <div className="page-content">
                <div className="info-card">
                    <h2>About the Cell</h2>
                    <p>The Students' Grievance Redressal Cell is constituted to address genuine grievances of students related to academic matters, examination issues, academic discrimination, library, hostel, or any other college-related concerns. All grievances are treated with strict confidentiality.</p>
                    <ul style={{ marginTop: '0.8rem' }}>
                        <li>Grievances are addressed within <strong>7 working days</strong>.</li>
                        <li>Contact: <a href="mailto:ascnighoj@gmail.com" style={{ color: '#2d6a4f' }}>ascnighoj@gmail.com</a></li>
                        <li>Phone: (02488) 230438</li>
                    </ul>
                </div>
                <div className="form-box">
                    <h2 style={{ color: '#1a3c5e', marginBottom: '1.2rem', fontSize: '1.2rem' }}>Submit a Grievance</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="form-row">
                            <div className="form-group">
                                <label>Full Name *</label>
                                <input required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Your name" />
                            </div>
                            <div className="form-group">
                                <label>Email</label>
                                <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="your@email.com" />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <label>Phone</label>
                                <input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="Mobile number" />
                            </div>
                            <div className="form-group">
                                <label>Department</label>
                                <select value={form.department} onChange={e => setForm({ ...form, department: e.target.value })}>
                                    <option value="">Select Department</option>
                                    <option>Arts</option>
                                    <option>Science</option>
                                    <option>Computer Science</option>
                                </select>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Grievance Details *</label>
                            <textarea required value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} placeholder="Describe your grievance in detail..." />
                        </div>
                        <button type="submit" className="submit-btn" disabled={submitting}>
                            {submitting ? 'Submitting…' : '📩 Submit Grievance'}
                        </button>
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default GrievanceCell;
